/* eslint-disable max-len */
import React, { FC } from 'react';
import { Box, BoxProps, chakra, useToken } from '@chakra-ui/react';

interface WavesProps extends BoxProps {
  color: string;
}

const Waves: FC<WavesProps> = React.memo(({ color, ...props }) => {
  const [baseColor] = useToken('colors', [color, 'base.50']);
  return (
    <Box position='absolute' bottom={0} left={0} width='100%' overflow='hidden' lineHeight={0} mb='-2px' {...props}>
      <chakra.svg
        position='relative'
        display='block'
        width={{ base: '1664', md: 'calc(100% + 1.3px)' }}
        height={{ base: '400', lg: 'inherit' }}
        viewBox='0 35 1610 658'
        xmlns='http://www.w3.org/2000/svg'
        preserveAspectRatio='none'
        className='transition duration-300 ease-in-out delay-150'
      >
        <defs>
          <path
            d='M526.480467,37.6240547 C562.692255,-16.2589338 631.210407,-2.54134049 635.127576,19.0165567 C664.491659,19.0165567 676.237292,61.133212 662.536011,72.8877907 C653.726786,59.1643201 626.318351,64.0718567 616.528365,81.7037247 C606.744253,99.3355926 626.318351,119.906105 649.809617,113.041431 C722.462233,91.8302942 765.797747,136.550589 757.722624,171.079663 C776.075176,196.058143 736.433664,237.199168 718.815214,214.424672 C742.30648,190.915515 697.526253,142.427878 635.127576,173.283647 C565.523422,207.702287 562.738764,270.871889 562.689973,279.546982 L562.689983,280.030229 C562.692093,280.368549 562.698127,280.544177 562.698127,280.544177 C599.896548,232.544355 669.389588,243.329181 674.769088,267.320276 C700.462661,260.708326 721.01752,290.829433 707.06958,315.073252 C719.549316,340.786393 691.653436,363.560889 676.237292,362.091566 C679.907803,355.479616 679.813838,339.475757 665.959863,329.031814 C627.310857,299.898091 542.630713,354.010294 601.35888,448.046923 C660.087047,542.083552 813.062176,541.248977 880.317673,511.227783 C982.357863,465.678791 1038.88372,462.005485 1129.91238,508.289138 C1369.85218,630.28991 1610.35234,486.284585 1610.35234,486.284585 L1610.35234,486.284585 L1610.35234,600.374507 L217.537,600.374 L217.537406,605.744099 L0,605.744099 L0,492.83732 C31.0591551,474.789601 44.6244129,473.44124 61.0319151,482.309954 C75.37528,490.056809 112.501639,524.605361 164.242977,525.482353 C163.606377,506.138855 151.875919,481.778219 126.39483,459.06684 C88.3977057,425.196022 103.684648,368.427284 138.874565,357.683599 C176.554557,346.181744 187.812747,377.531205 187.812747,377.531205 C178.022761,360.381275 144.277557,394.863332 171.668374,413.276879 C204.450436,435.316714 260.365524,382.861907 222.562203,329.031814 C184.388895,274.666888 189.527609,211.486027 226.966816,187.242209 C257.487844,167.482762 290.099595,184.303564 287.163187,210.016705 C262.203716,185.038226 237.719943,231.092665 266.608328,245.280441 C285.477688,254.548926 321.014102,242.365306 348.827762,146.835845 C380.423516,38.3175749 489.775363,8.71954586 526.480467,37.6240547 Z'
            id='path-1'
          />
          <filter x='-3.4%' y='-6.9%' width='105.5%' height='114.5%' filterUnits='objectBoundingBox' id='filter-2'>
            <feMorphology radius='3' operator='dilate' in='SourceAlpha' result='shadowSpreadOuter1' />
            <feOffset dx='-10' dy='2' in='shadowSpreadOuter1' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='10' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-2.3%' y='-4.2%' width='103.4%' height='109.1%' filterUnits='objectBoundingBox' id='filter-3'>
            {/* <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' /> */}
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
          <path
            d='M845.352344,161.497649 C845.352344,169.507449 838.856344,175.997649 830.852344,175.997649 C822.842544,175.997649 816.352344,169.507449 816.352344,161.497649 C816.352344,153.487849 822.842544,146.997649 830.852344,146.997649 C838.856344,146.997649 845.352344,153.487849 845.352344,161.497649'
            id='path-4'
          />
          <filter x='-72.4%' y='-27.6%' width='196.6%' height='182.8%' filterUnits='objectBoundingBox' id='filter-5'>
            <feOffset dx='-9' dy='4' in='SourceAlpha' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='2.5' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-53.4%' y='-8.6%' width='158.6%' height='144.8%' filterUnits='objectBoundingBox' id='filter-6'>
            <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' />
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
          <path
            d='M857.352344,486.497649 C857.352344,494.507449 850.856344,500.997649 842.852344,500.997649 C834.842544,500.997649 828.352344,494.507449 828.352344,486.497649 C828.352344,478.487849 834.842544,471.997649 842.852344,471.997649 C850.856344,471.997649 857.352344,478.487849 857.352344,486.497649'
            id='path-7'
          />
          <filter x='-72.4%' y='-27.6%' width='196.6%' height='182.8%' filterUnits='objectBoundingBox' id='filter-8'>
            <feOffset dx='-9' dy='4' in='SourceAlpha' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='2.5' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-53.4%' y='-8.6%' width='158.6%' height='144.8%' filterUnits='objectBoundingBox' id='filter-9'>
            {/* <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' /> */}
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
          <path
            d='M757.352344,107.000519 C757.352344,110.857837 754.219557,113.997649 750.346607,113.997649 C746.479394,113.997649 743.352344,110.857837 743.352344,107.000519 C743.352344,103.12598 746.479394,99.9976485 750.346607,99.9976485 C754.219557,99.9976485 757.352344,103.12598 757.352344,107.000519'
            id='path-10'
          />
          <filter x='-150.0%' y='-57.1%' width='300.0%' height='271.4%' filterUnits='objectBoundingBox' id='filter-11'>
            <feOffset dx='-9' dy='4' in='SourceAlpha' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='2.5' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-110.7%' y='-17.9%' width='221.4%' height='192.9%' filterUnits='objectBoundingBox' id='filter-12'>
            {/* <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' /> */}
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
          <path
            d='M345.339831,260.371453 C363.935167,198.733407 417.754193,219.279422 411.8826,237.624079 C406.011006,230.286216 386.194378,238.357865 388.396226,253.767377 C390.598073,269.176888 419.956041,276.514751 451.515856,247.897087 C483.075671,219.279422 529.31447,235.42272 535.186063,261.105239 C541.057657,286.787758 513.167588,298.528338 505.828096,288.255331 C515.369435,281.651254 503.626248,255.234949 478.671976,271.378247 C453.717704,287.521544 457.38745,313.204064 457.38745,313.204064 C466.928789,305.132415 497.020706,305.132415 499.222553,329.347361 C529.31447,313.204064 559.406387,341.821728 544.727403,357.965025 C517.571283,355.763667 497.531534,411.519682 543.993454,461.428888 C612.984677,535.5413 731.884446,548.015666 731.884446,548.015666 L731.884446,548.015666 L733.352344,604.76376 L196.729,605.734545 L196.729136,605.744099 L60.9085946,605.747649 L0.352344357,605.744099 L0,537.458274 C4.39514351,536.000629 9.19868761,534.427483 14.1359369,532.883224 L15.5499805,532.442919 L15.5499805,532.442919 L16.9698769,532.004933 C34.7492282,526.547739 53.566619,521.809821 60.9085946,524.368715 C83.3250897,532.171238 108.219774,572.342388 172.991862,554.182315 C183.05467,524.028041 220.633348,519.904795 220.251403,535.969831 C217.744232,534.302669 206.048018,538.893236 208.972071,554.343839 C213.017599,575.699954 251.153599,576.891623 256.285372,551.92528 C261.857514,524.81628 241.606388,526.495183 229.863201,491.273443 C218.120014,456.045832 228.888517,445.28559 242.586944,434.519478 C234.76011,417.883076 247.477982,392.45298 271.944912,394.407786 C292.495489,367.011142 313.046066,389.517834 313.046066,389.517834 C313.046066,389.517834 297.386526,393.427448 296.411842,411.038318 C294.186508,451.138269 348.275627,456.045832 337.507125,418.869285 C326.744494,381.698608 369.800889,373.861771 369.800889,373.861771 C369.800889,373.861771 326.744494,322.009499 345.339831,260.371453 Z'
            id='path-13'
          />
          <filter x='-7.4%' y='-10.9%' width='112.0%' height='122.8%' filterUnits='objectBoundingBox' id='filter-14'>
            <feMorphology radius='3' operator='dilate' in='SourceAlpha' result='shadowSpreadOuter1' />
            <feOffset dx='-10' dy='2' in='shadowSpreadOuter1' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='10' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-5.1%' y='-6.6%' width='107.5%' height='114.2%' filterUnits='objectBoundingBox' id='filter-15'>
            {/* <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' /> */}
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
          <path
            d='M325.352344,95.4947495 C325.352344,100.741927 321.097921,104.997649 315.852344,104.997649 C310.606768,104.997649 306.352344,100.741927 306.352344,95.4947495 C306.352344,90.2417742 310.606768,85.9976485 315.852344,85.9976485 C321.097921,85.9976485 325.352344,90.2417742 325.352344,95.4947495'
            id='path-16'
          />
          <filter x='-110.5%' y='-42.1%' width='247.4%' height='226.3%' filterUnits='objectBoundingBox' id='filter-17'>
            <feOffset dx='-9' dy='4' in='SourceAlpha' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='2.5' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-81.6%' y='-13.2%' width='189.5%' height='168.4%' filterUnits='objectBoundingBox' id='filter-18'>
            {/* <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' /> */}
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
          <path
            d='M514.352344,201.497649 C514.352344,206.737429 510.102421,210.997649 504.849445,210.997649 C499.602268,210.997649 495.352344,206.737429 495.352344,201.497649 C495.352344,196.246276 499.602268,191.997649 504.849445,191.997649 C510.102421,191.997649 514.352344,196.246276 514.352344,201.497649'
            id='path-19'
          />
          <filter x='-110.5%' y='-42.1%' width='247.4%' height='226.3%' filterUnits='objectBoundingBox' id='filter-20'>
            <feOffset dx='-9' dy='4' in='SourceAlpha' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='2.5' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-81.6%' y='-13.2%' width='189.5%' height='168.4%' filterUnits='objectBoundingBox' id='filter-21'>
            {/* <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' /> */}
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
          <path
            d='M465.352344,209.489018 C465.352344,213.637464 461.9992,216.997649 457.858096,216.997649 C453.71124,216.997649 450.352344,213.637464 450.352344,209.489018 C450.352344,205.346325 453.71124,201.997649 457.858096,201.997649 C461.9992,201.997649 465.352344,205.346325 465.352344,209.489018'
            id='path-22'
          />
          <filter x='-140.0%' y='-53.3%' width='286.7%' height='260.0%' filterUnits='objectBoundingBox' id='filter-23'>
            <feOffset dx='-9' dy='4' in='SourceAlpha' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='2.5' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-103.3%' y='-16.7%' width='213.3%' height='186.7%' filterUnits='objectBoundingBox' id='filter-24'>
            {/* <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' /> */}
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
          <path
            d='M782.352344,441.497649 C782.352344,446.737429 778.102421,450.997649 772.855243,450.997649 C767.602268,450.997649 763.352344,446.737429 763.352344,441.497649 C763.352344,436.246276 767.602268,431.997649 772.855243,431.997649 C778.102421,431.997649 782.352344,436.246276 782.352344,441.497649'
            id='path-25'
          />
          <filter x='-110.5%' y='-42.1%' width='247.4%' height='226.3%' filterUnits='objectBoundingBox' id='filter-26'>
            <feOffset dx='-9' dy='4' in='SourceAlpha' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='2.5' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-81.6%' y='-13.2%' width='189.5%' height='168.4%' filterUnits='objectBoundingBox' id='filter-27'>
            {/* <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' /> */}
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
          <path
            d='M412.787411,422.592042 C417.192597,380.964547 479.352712,378.025997 479.352712,420.634968 C470.54234,414.264192 444.117096,430.426216 470.054832,475.485938 C471.029847,444.631165 517.530993,448.057514 518.511881,471.078113 C526.828873,471.565912 537.107641,480.381561 537.107641,493.117236 C537.107641,505.852911 525.243006,507.439727 521.936179,503.76654 C527.445599,497.525061 516.432633,490.178686 511.657412,501.562628 C506.888063,512.952447 522.834837,534.18053 547.268937,525.805663 C586.915614,512.217809 616.735788,515.385566 629.863243,523.972008 C658.496954,542.702324 690.067455,564.377067 719.435364,546.011131 C719.435364,546.011131 713.19762,526.540301 727.511538,519.193926 C729.34997,497.154803 735.223551,489.073792 754.676854,482.097674 C774.13603,475.11568 805.336496,485.036224 801.301345,506.70509 C795.427764,497.889441 781.971388,504.31311 778.905378,521.033458 C774.500192,545.029656 808.437747,583.947808 878.26876,552.37603 C959.518015,515.638281 1011.40524,515.732315 1075.52125,539.640355 C1212.08203,590.5713 1410.31541,599.386949 1610.01719,532.293981 L1610.01719,532.293981 L1610.01719,605.747649 L208.354615,605.743577 C208.353143,605.746278 208.352344,605.747649 208.352344,605.747649 L208.352344,605.747649 L0.352344357,605.747649 L0.352344357,605.747649 L0.352344357,580.291809 L0.352344357,580.291809 L5.9445781,581.219332 L5.9445781,581.219332 L11.5364705,582.145204 C61.8609419,590.465663 112.102465,598.384824 161.141233,600.485176 C168.112268,600.783748 174.018635,600.450538 179.05136,600.082744 C174.201981,593.64727 167.758545,582.888093 170.625512,574.044896 C178.431502,549.954665 202.560175,559.352147 199.259222,565.963884 C196.322432,564.494609 190.44885,568.167796 191.54721,576.613188 C192.651443,585.064457 205.250276,593.02205 220.915118,594.491325 C277.935849,599.839485 320.766007,579.551738 320.766007,579.551738 C260.561794,570.001451 261.049302,510.754411 264.966981,509.772936 C257.995039,498.624078 262.764388,476.220575 280.020971,471.81275 C282.100219,464.213661 290.910591,455.398011 310.974746,456.37361 C323.356256,456.978951 332.149008,469.238581 328.107984,477.319593 C324.072833,469.973218 308.284646,480.246388 314.892425,498.982581 C321.500204,517.718774 343.573124,514.292425 351.238149,507.075347 C356.355507,502.256126 356.199433,496.81055 355.636997,491.306508 L355.552353,490.500687 L355.552353,490.500687 L355.465297,489.694426 C354.666588,482.302903 353.991096,474.905868 365.187905,468.874201 C369.957253,466.300031 382.074452,466.670288 384.641208,475.11568 C375.466673,475.850318 377.974692,498.524167 397.122569,494.216254 C426.00297,487.727936 409.780137,450.990187 412.787411,422.592042 Z'
            id='path-28'
          />
          <filter x='-3.4%' y='-19.5%' width='105.5%' height='140.8%' filterUnits='objectBoundingBox' id='filter-29'>
            <feMorphology radius='3' operator='dilate' in='SourceAlpha' result='shadowSpreadOuter1' />
            <feOffset dx='-10' dy='2' in='shadowSpreadOuter1' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='10' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-2.3%' y='-11.8%' width='103.4%' height='125.5%' filterUnits='objectBoundingBox' id='filter-30'>
            {/* <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' /> */}
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
          <path
            d='M271.352344,305.497649 C271.352344,309.634576 267.995091,312.997649 263.852344,312.997649 C259.709598,312.997649 256.352344,309.634576 256.352344,305.497649 C256.352344,301.349084 259.709598,297.997649 263.852344,297.997649 C267.995091,297.997649 271.352344,301.349084 271.352344,305.497649'
            id='path-31'
          />
          <filter x='-140.0%' y='-53.3%' width='286.7%' height='260.0%' filterUnits='objectBoundingBox' id='filter-32'>
            <feOffset dx='-9' dy='4' in='SourceAlpha' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='2.5' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-103.3%' y='-16.7%' width='213.3%' height='186.7%' filterUnits='objectBoundingBox' id='filter-33'>
            {/* <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' /> */}
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
          <path
            d='M711.352344,453.497649 C711.352344,458.737429 707.102421,462.997649 701.855243,462.997649 C696.602268,462.997649 692.352344,458.737429 692.352344,453.497649 C692.352344,448.246276 696.602268,443.997649 701.855243,443.997649 C707.102421,443.997649 711.352344,448.246276 711.352344,453.497649'
            id='path-34'
          />
          <filter x='-110.5%' y='-42.1%' width='247.4%' height='226.3%' filterUnits='objectBoundingBox' id='filter-35'>
            <feOffset dx='-9' dy='4' in='SourceAlpha' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='2.5' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-81.6%' y='-13.2%' width='189.5%' height='168.4%' filterUnits='objectBoundingBox' id='filter-36'>
            {/* <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' /> */}
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
          <path
            d='M328.352344,342.006575 C328.352344,349.189454 322.534911,354.997649 315.355319,354.997649 C308.175726,354.997649 302.352344,349.189454 302.352344,342.006575 C302.352344,334.817745 308.175726,328.997649 315.355319,328.997649 C322.534911,328.997649 328.352344,334.817745 328.352344,342.006575'
            id='path-37'
          />
          <filter x='-80.8%' y='-30.8%' width='207.7%' height='192.3%' filterUnits='objectBoundingBox' id='filter-38'>
            <feOffset dx='-9' dy='4' in='SourceAlpha' result='shadowOffsetOuter1' />
            {/* <feGaussianBlur stdDeviation='2.5' in='shadowOffsetOuter1' result='shadowBlurOuter1' /> */}
            <feColorMatrix
              values='0 0 0 0 0   0 0 0 0 0.0470588235   0 0 0 0 0.0862745098  0 0 0 0.35 0'
              type='matrix'
              in='shadowBlurOuter1'
            />
          </filter>
          <filter x='-59.6%' y='-9.6%' width='165.4%' height='150.0%' filterUnits='objectBoundingBox' id='filter-39'>
            {/* <feGaussianBlur stdDeviation='0.5' in='SourceAlpha' result='shadowBlurInner1' /> */}
            <feOffset dx='2' dy='2' in='shadowBlurInner1' result='shadowOffsetInner1' />
            <feComposite
              in='shadowOffsetInner1'
              in2='SourceAlpha'
              operator='arithmetic'
              k2='-1'
              k3='1'
              result='shadowInnerInner1'
            />
            <feColorMatrix
              values='0 0 0 0 0.878431373   0 0 0 0 0.960784314   0 0 0 0 0.988235294  0 0 0 0.3 0'
              type='matrix'
              in='shadowInnerInner1'
            />
          </filter>
        </defs>
        <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
          <g transform='matrix(-1 0 0 1 1610 89.002)'>
            <g id='wave-3' className='slide-in-bottom-1'>
              <use fill='#000' filter='url(#filter-2)' xlinkHref='#path-1' />
              <use fill={`${baseColor}66`} xlinkHref='#path-1' />
              <use fill='#000' filter='url(#filter-3)' xlinkHref='#path-1' />
            </g>
            {/* Boat */}
            <g className='wobble-hor-bottom'>
              <g id='Boat' transform='translate(1142.000000, 491.997649) scale(0.7, 0.7)'>
                <polygon
                  id='boat-06'
                  fill='#CDCDCD'
                  points='0 45.2857371 172.824338 59.1415707 347.824338 45.2857371 173.324476 85.7700279'
                />
                <polygon
                  id='boat-05'
                  fill='#FCFCFC'
                  points='174.20202 7.10542736e-15 118.687247 78.0104323 173.824338 85.7700279'
                />
                <polygon
                  id='boat-04'
                  fill='#EEEEEE'
                  transform='translate(201.263248, 42.885014) scale(-1, 1) translate(-201.263248, -42.885014) '
                  points='228.839249 7.10542736e-15 173.324476 78.0104323 229.20202 85.7700279'
                />
                <polygon
                  id='boat-03'
                  fill='#E6E4E5'
                  points='1 45.2857371 79.1489698 139.914195 173.824338 85.7700279'
                />
                <polygon
                  id='boat-02'
                  fill='#E6E4E5'
                  transform='translate(260.574407, 92.599966) scale(-1, 1) translate(-260.574407, -92.599966) '
                  points='173.324476 45.2857371 251.473445 139.914195 347.824338 85.7700279'
                />
                <polygon
                  id='boat-01'
                  fill='#FCFCFC'
                  points='79.1489698 139.914195 173.824338 85.7700279 269.675368 139.914195'
                />
              </g>
            </g>
            <g id='wave-2' className='slide-in-bottom'>
              <use fill='#000' filter='url(#filter-14)' xlinkHref='#path-13' />
              <use fill={`${baseColor}88`} xlinkHref='#path-13' />
              <use fill='#000' filter='url(#filter-15)' xlinkHref='#path-13' />
            </g>
            <g className='slide-in-bottom-2'>
              <g>
                <use fill='#000' filter='url(#filter-5)' xlinkHref='#path-4' />
                <use fill={`${baseColor}66`} xlinkHref='#path-4' />
                <use fill='#000' filter='url(#filter-6)' xlinkHref='#path-4' />
              </g>
              <g>
                <use fill='#000' filter='url(#filter-8)' xlinkHref='#path-7' />
                <use fill={`${baseColor}66`} xlinkHref='#path-7' />
                <use fill='#000' filter='url(#filter-9)' xlinkHref='#path-7' />
              </g>
              <g>
                <use fill='#000' filter='url(#filter-11)' xlinkHref='#path-10' />
                <use fill={`${baseColor}66`} xlinkHref='#path-10' />
                <use fill='#000' filter='url(#filter-12)' xlinkHref='#path-10' />
              </g>
              <g fillRule='nonzero'>
                <use fill='#000' filter='url(#filter-17)' xlinkHref='#path-16' />
                <use fill={`${baseColor}ff`} xlinkHref='#path-16' />
                <use fill='#000' filter='url(#filter-18)' xlinkHref='#path-16' />
              </g>
              <g fillRule='nonzero'>
                <use fill='#000' filter='url(#filter-20)' xlinkHref='#path-19' />
                <use fill={`${baseColor}ff`} xlinkHref='#path-19' />
                <use fill='#000' filter='url(#filter-21)' xlinkHref='#path-19' />
              </g>
              <g fillRule='nonzero'>
                <use fill='#000' filter='url(#filter-23)' xlinkHref='#path-22' />
                <use fill={`${baseColor}ff`} xlinkHref='#path-22' />
                <use fill='#000' filter='url(#filter-24)' xlinkHref='#path-22' />
              </g>
              <g fillRule='nonzero'>
                <use fill='#000' filter='url(#filter-26)' xlinkHref='#path-25' />
                <use fill={`${baseColor}ff`} xlinkHref='#path-25' />
                <use fill='#000' filter='url(#filter-27)' xlinkHref='#path-25' />
              </g>
              <g fillRule='nonzero'>
                <use fill='#000' filter='url(#filter-32)' xlinkHref='#path-31' />
                <use fill={`${baseColor}ff`} xlinkHref='#path-31' />
                <use fill='#000' filter='url(#filter-33)' xlinkHref='#path-31' />
              </g>
              <g fillRule='nonzero'>
                <use fill='#000' filter='url(#filter-35)' xlinkHref='#path-34' />
                <use fill={`${baseColor}ff`} xlinkHref='#path-34' />
                <use fill='#000' filter='url(#filter-36)' xlinkHref='#path-34' />
              </g>
              <g fillRule='nonzero'>
                <use fill='#000' filter='url(#filter-38)' xlinkHref='#path-37' />
                <use fill={`${baseColor}ff`} xlinkHref='#path-37' />
                <use fill='#000' filter='url(#filter-39)' xlinkHref='#path-37' />
              </g>
            </g>
            <g id='wave-1' fillRule='nonzero'>
              <use fill='#000' filter='url(#filter-29)' xlinkHref='#path-28' />
              <use fill={`${baseColor}ff`} xlinkHref='#path-28' />
              <use fill='#000' filter='url(#filter-30)' xlinkHref='#path-28' />
            </g>
          </g>
        </g>
      </chakra.svg>
    </Box>
  );
});

Waves.displayName = 'Waves';
export default Waves;
